import { ComponentFactoryResolver, Injectable, ViewContainerRef } from '@angular/core';
import { UtilService } from './util.service';
import { CtMessageComponent, CtViewComponent } from '../controls';
import { ADN_PLUS } from '../models';
import { PaintService } from './paint.service';
import { CtMessageSize, CtMessageStyle, CtMessageType, CtMessageVisualization } from '../enums/plusMessage';

@Injectable({
  providedIn: 'root'
})
export class PlusMessageService {

  private message : string;
  private type : CtMessageType;
  private canBeClosed : boolean;
  private container : ViewContainerRef;
  private ctMessage : CtMessageComponent;

  constructor(private utilService : UtilService,
              private componentFactoryResolver: ComponentFactoryResolver) {}

  /**
   * Public function to display a message with the specified ADN_PLUS configuration.
   * @param ADN - The ADN_PLUS configuration object to define the message properties.
   */
  public showMessage(ADN : ADN_PLUS) {
    this.getAdnvalue(ADN);
    this.container = this.getContainer();
    this.paintMessage();
  }

  /**
   * Public function to hide the currently displayed message.
   */
  public hideMessage() {
    this.container.clear();
  }

  /**
   * Private function to retrieve the message properties from the ADN_PLUS configuration.
   * @param ADN - The ADN_PLUS configuration object to define the message properties.
   */
  private getAdnvalue(ADN : ADN_PLUS) {
    this.message = this.utilService.getStringAttribute('MESSAGE',ADN.ArrayEntities.List);
    this.type = this.utilService.getStringAttribute('TYPE',ADN.ArrayEntities.List);
    this.canBeClosed = this.utilService.getStringAttribute('CANBECLOSED',ADN.ArrayEntities.List);
  }

  /**
   * Private function to obtain the container for the message component.
   * @returns ViewContainerRef - The container for the message component.
   */
  private getContainer() : ViewContainerRef {
    const component : CtViewComponent = this.utilService.getComponentRef(this.utilService.currentViewId).getRoot();
    return component.messageContainer;
  }

  /**
   * Private function to create and insert the message component in the container.
   */
  private paintMessage() {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(CtMessageComponent);
    this.container.clear();
    this.ctMessage = this.container.createComponent(componentFactory).instance;
    this.setMessageData();
  }

  /**
   * Private function to set the message component's data according to the message properties.
   */
  private setMessageData() {
    this.ctMessage.setMetaData({
      ctType: "CtMessage",
      controlProperties: {
        actionIcon: "",
        actionText: "",
        hidden: false,
        canBeClosed: this.canBeClosed,
        size: CtMessageSize.large,
        style: CtMessageStyle.unicolor,
        type: this.type,
        visualization: CtMessageVisualization.float,
        message: this.message,
        title: "Error",
        id: "CtMessage_default",
      },
      controlActions: [],
      models: []
    })
  }
  
}